
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_delete: false,
            modal_add: false,

            loading: false,
            data: null,
            barcode_config: null,

            product_id: "",
            product_code: "",
            product_name: "",
            product_type: "",
            sale_price: 0,
            cost_price: 0,
            description: "",

            page: 1,
            data_search: ""

        }
    }
    async componentDidMount() {
        await this.Get();
    }
    
    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            product_id: ""
        }

        let result = await GET(tokens, "v1/TH/product-manage/product/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }

    DeleteProduct = async () => {

        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/product-manage/product/delete/" + this.state.product_id, null);
        if (result && result.status) {
            success_url("/master/list-spare-parts-repair");
        }
        this.setState({ loading: false });
    }

    clear_form = () => {
        this.setState({
            modal_delete: false,
            modal_add: false,

            loading: false,

            product_id: "",
            product_code: "",
            product_name: "",
            product_type: "",
            sale_price: 0,
            cost_price: 0,
            description: "",
        })
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการระบบ" page3="จัดการอะไหล่และการซ่อม" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>จัดการอะไหล่และการซ่อม</b></h3>
                            <div className="d-flex">
                                <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master" }}>
                                    <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                                </button>
                                <button className="btn btn-orange mx-1" onClick={() => { this.setState({ modal_add: true }) }}>
                                    เพิ่มสินค้า
                                </button>
                            </div>
                        </div>
                        <div className="w-100 card border-0 p-0">
                            <div className="d-flex flex-wrap mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder=""
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1 });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />


                                <button className="btn btn-orange mx-1" onClick={() => {
                                    this.setState({ page: 1 });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1" onClick={() => {
                                    this.setState({ page: 1, data_search: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-center text-white">รหัสสินค้า</th>
                                            <th className="text-left text-white">ชื่อสินค้า</th>
                                            <th className="text-left text-white">รายละเอียด</th>
                                            <th className="text-center text-white">ประเภท</th>
                                            <th className="text-center text-white">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">{item.product_code ? item.product_code : "-"}</td>
                                                <td className="text-left">{item.product_name ? item.product_name : "-"}</td>
                                                <td className="text-left">{item.product_detail ? item.product_detail : "-"}</td>
                                                <td className="text-center">{item.product_type ? item.product_type : "-"}</td>
                                                <td className="text-center">
                                                    <div className="w-100 d-flex justify-content-center">
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => { window.location.href = "/master/spare-parts-repair/update?type=" + item.product_type + "&id=" + item.product_id }}>
                                                            <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                        </div>
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => {
                                                                this.setState({
                                                                    modal_delete: true,
                                                                    product_id: item.product_id,
                                                                    product_code: item.product_code,
                                                                    product_name: item.product_name,
                                                                    product_type: item.product_type,
                                                                    sale_price: item.sale_price,
                                                                    cost_price: item.cost_price,
                                                                    description: item.description,
                                                                })
                                                            }}>
                                                            <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                { this.state.data && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} 
                                        />
                                    </div>
                                ) }
                            </div>
                        </div>
                    </div>
                </div>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_add} onHide={() => { this.setState({ modal_add: false }) }}>
                    <Modal.Header> <Modal.Title> <b>คุณต้องการเพิ่มสินค้าประเภทใด</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-6">
                                <div className="w-100 hpx-150 me-3 mb-2 card pointer rounded-lg border-0 shadow py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                    onClick={() => { window.location.href = "/master/spare-parts-repair/create?type=อะไหล่" }}
                                >
                                    <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                        <span className="icon text-32">{"\uf7d9"}</span>
                                    </div>
                                    <label>อะไหล่</label>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="w-100 hpx-150 me-3 mb-2 card pointer rounded-lg border-0 shadow py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                    onClick={() => { window.location.href = "/master/spare-parts-repair/create?type=การซ่อม" }}
                                >
                                    <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                        <span className="icon text-32">{"\uf4fe"}</span>
                                    </div>
                                    <label>การซ่อม</label>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex justify-content-center">
                            <button className="btn btn-outline-orange px-4" onClick={() => { this.setState({ modal_add: false }) }}>
                                ยกเลิก
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบสินค้า</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบสินค้า “{this.state.product_name}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.DeleteProduct() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
